import React from "react";
import { FormattedMessage } from "react-intl";

export const BrandedPackagingLabel = () => (
  <FormattedMessage id={"label.brandedPackaging"} defaultMessage={"Branded Packaging"} />
);
